export default {
    routerName: '外汇新增',
    exchange: {
        jpy: '100日元',
        usd: '1美元',
        hkd: '1港元',
        eur: '1欧元',
        gpb: '1英镑',
        year: '年',
        month: '月',
        day: '日',
        createTime: '作成日付',
    },
};
